<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color table-textcenter"
      :data="AllMedicalCancer.data"
      border
    >
      <el-table-column
        label="Image"
        prop="image"
        min-width="100px"
        min-height="100px"
      >
        <template slot-scope="scope">
          <img :src="`${$imageURL}/${scope.row.picture}`" alt="image" />
        </template>
      </el-table-column>
      <el-table-column label="Title" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Description" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.description }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Category" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.category }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Location" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.location }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Link" prop="title">
        <template v-slot="{ row }">
          <a
            class="font-semibold text-left name mb-0 text-sm"
            target="blank"
            :href="row.link"
          >
            visit link
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Date" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="AllMedicalCancer.count"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
// import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
    };
  },

  methods: {
    async function() {
      let loader = this.$loading();
      let payload = {
        limit: this.perPage,
        offset: this.perPage * this.currentPage - this.perPage,
        pagination: true,
      };

      try {
        this.$store.dispatch("medicalCancer/getMedicalCancer", payload);
      } catch (error) {
        console.log(error);
      }
      loader.close();
    },

    async handleEdit(scope) {
      let { row } = scope;
      await this.$store.commit(
        "medicalCancer/SET_SELECTED_MEDICAL_FOR_UPDATE",
        row
      );
      this.$router.push({ name: "editMedical" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
        this.$swal.fire({
          text: "Data Successfully Deleted",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { id: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch(
          "medicalCancer/deleteMedicalCancer",
          payload
        );
        this.function();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.function();
    },
  },
  computed: {
    ...mapState("medicalCancer", ["AllMedicalCancer"]),
  },
  async mounted() {
    await this.function();
    // console.log("1234", this.AllMedicalCancer);
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
